import Spinner from '../spinner';
import Tooltip from '../tooltip';
import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    value, min, max, className,
    disabled, isRange, animate,
    isShowInput, isShowEnd, unit,
    step, _isDragging, _isFirst,
    _isSecond, _sliderValue, always,
    isShowStop, marks, showTooltip,
    tooltipProps, spinnerPrefix, spinnerSuffix,
} = self.get();

const classNameObj = {
    'k-slider': true,
    'k-disabled': disabled,
    [className]: className,
    'k-dragging': _isDragging || !animate,
    'k-show-input': isShowInput && !isRange,
    'k-show-end': isShowEnd,
};

const sliderWidth = max - min;
const toPercent = (value) => value / sliderWidth * 100 + '%';
let barStyle;
let handleStartStyle;
let handleEndStyle;
if (sliderWidth) {
    if (isRange) {
        barStyle = {
            width: toPercent(Math.abs(_sliderValue[1] - _sliderValue[0])),
            left: toPercent(Math.min(_sliderValue[0], _sliderValue[1]) - min),
        };
        handleStartStyle = {
            left: toPercent(_sliderValue[0] - min),
        };
        handleEndStyle = {
            left: toPercent(_sliderValue[1] - min),
        };
    } else {
        barStyle = {
            width: toPercent(_sliderValue - min),
        };
        handleStartStyle = {
            left: toPercent(_sliderValue - min),
        };
    }
} else {
    barStyle = {width: '100%', left: '0'};
    handleStartStyle = {left: '100%'};
    handleEndStyle = {left: '0'};
}

const tooltip = (value) => {
    return (_blocks['tooltip'] = function(parent) {
        return function() {try {return (value )} catch(e) {_e(e)}}.call($this);
    }) && (__blocks['tooltip'] = function(parent) {
        var args = arguments;
        return blocks['tooltip'] ? blocks['tooltip'].apply($this, [function() {
            return _blocks['tooltip'].apply($this, args);
        }].concat(__slice.call(args, 1))) : _blocks['tooltip'].apply($this, args);
    }) && __blocks['tooltip'].apply($this, [__noop].concat(function() {try {return ([value] )} catch(e) {_e(e)}}.call($this)));
};
const _tooltipProps = {
    container: dom => dom.parentElement,
    canHover: true,
    always,
    ...tooltipProps,
};
if (always) {
    _tooltipProps.value = true;
}

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        h('div', null, [
            h('div', {
                'ev-click': function() {try {return (self._clickWrapper )} catch(e) {_e(e)}}.call($this)
            }, h('div', null, [
                h('div', {
                    'style': function() {try {return (barStyle )} catch(e) {_e(e)}}.call($this)
                }, null, 'k-bar'),
                h('div', {
                    'style': function() {try {return (handleStartStyle )} catch(e) {_e(e)}}.call($this)
                }, h(Tooltip, {
                    'ref': function(i) {widgets['tooltip1'] = i},
                    'disabled': function() {try {return (!showTooltip )} catch(e) {_e(e)}}.call($this),
                    ...function() {try {return (_tooltipProps )} catch(e) {_e(e)}}.call($this),
                    'children': h('div', {
                        'tabindex': function() {try {return (disabled ? "-1" : "0" )} catch(e) {_e(e)}}.call($this),
                        'ev-mousedown': function() {try {return (isRange ? 
                                self._onDrag.bind(self, '_isFirst') : 
                                self._onDrag.bind(self, undefined)
                            )} catch(e) {_e(e)}}.call($this),
                        'ev-click': function() {try {return (self._stopPropagation )} catch(e) {_e(e)}}.call($this),
                        'ev-keydown': function() {try {return (isRange ? 
                                self._onKeydown.bind(self, '_isFirst') :
                                self._onKeydown.bind(self, undefined)
                            )} catch(e) {_e(e)}}.call($this),
                        'ev-keyup': function() {try {return (self._onKeyUp )} catch(e) {_e(e)}}.call($this),
                        'ev-focusin': function() {try {return (self._onFocusin.bind(self, '_isFirst') )} catch(e) {_e(e)}}.call($this),
                        'ev-focusout': function() {try {return (self._onFocusout.bind(self, '_isFirst') )} catch(e) {_e(e)}}.call($this)
                    }, null, _className(function() {try {return ({
                                "k-handle": true, 
                                "k-active": (_isFirst && _sliderValue[1] === self._max) || 
                                    (_isSecond && value[0] !== self._min)
                            } )} catch(e) {_e(e)}}.call($this)), null, function() {try {return (dom => self.$sliderFirstBtn = dom )} catch(e) {_e(e)}}.call($this)),
                    '_context': $this,
                    '_blocks': function(blocks) {
                        var _blocks = {}, __blocks = extend({}, blocks);
                        return ((_blocks['content'] = function(parent) {
                            return function() {try {return (tooltip(isRange ? value[0] : value) )} catch(e) {_e(e)}}.call($this);
                        }) && (__blocks['content'] = function(parent) {
                            var args = arguments;
                            return blocks['content'] ? blocks['content'].apply($this, [function() {
                                return _blocks['content'].apply($this, args);
                            }].concat(__slice.call(args, 1))) : _blocks['content'].apply($this, args);
                        }), __blocks);
                    }.call($this, {})
                }), 'k-handle-wrapper'),
                function() {try {return (isRange )} catch(e) {_e(e)}}.call($this) ?
                    h('div', {
                        'style': function() {try {return (handleEndStyle )} catch(e) {_e(e)}}.call($this)
                    }, h(Tooltip, {
                        'ref': function(i) {widgets['tooltip2'] = i},
                        'disabled': function() {try {return (!showTooltip )} catch(e) {_e(e)}}.call($this),
                        ...function() {try {return (_tooltipProps )} catch(e) {_e(e)}}.call($this),
                        'children': h('div', {
                            'tabindex': function() {try {return (disabled ? "-1" : "0" )} catch(e) {_e(e)}}.call($this),
                            'ev-mousedown': function() {try {return (self._onDrag.bind(self, "_isSecond") )} catch(e) {_e(e)}}.call($this),
                            'ev-keydown': function() {try {return (self._onKeydown.bind(self, '_isSecond') )} catch(e) {_e(e)}}.call($this),
                            'ev-focusin': function() {try {return (self._onFocusin.bind(self, '_isSecond') )} catch(e) {_e(e)}}.call($this),
                            'ev-focusout': function() {try {return (self._onFocusout.bind(self, '_isSecond') )} catch(e) {_e(e)}}.call($this),
                            'ev-click': function() {try {return (self._stopPropagation )} catch(e) {_e(e)}}.call($this)
                        }, null, _className(function() {try {return ({
                                "k-handle": true,
                                "k-active": (_isSecond && _sliderValue[0] === self._min) || 
                                    (_isFirst && _sliderValue[1] !== self._max)
                            } )} catch(e) {_e(e)}}.call($this)), null, function() {try {return (dom => self.$sliderSecondBtn = dom )} catch(e) {_e(e)}}.call($this)),
                        '_context': $this,
                        '_blocks': function(blocks) {
                            var _blocks = {}, __blocks = extend({}, blocks);
                            return ((_blocks['content'] = function(parent) {
                                return function() {try {return (tooltip(value[1]) )} catch(e) {_e(e)}}.call($this);
                            }) && (__blocks['content'] = function(parent) {
                                var args = arguments;
                                return blocks['content'] ? blocks['content'].apply($this, [function() {
                                    return _blocks['content'].apply($this, args);
                                }].concat(__slice.call(args, 1))) : _blocks['content'].apply($this, args);
                            }), __blocks);
                        }.call($this, {})
                    }), 'k-handle-wrapper') :
                    undefined,
                function() {try {return ((() => {
                    if (isShowStop && step) {
                        const ret = [];
                        const total = max - min;
                        let i = min;
                        while (true) {
                            let [step] = self._getStep(i, 'increase');
                            i = i + step;
                            if (Number(i.toFixed(10)) >= max) {
                                break
                            }

                            ret.push(h('i', {
                    'style': function() {try {return ({left: ((i - min) / total * 100) + '%'} )} catch(e) {_e(e)}}.call($this)
                }, null, 'k-point'));
                        }
                        return ret;
                    }
                })() )} catch(e) {_e(e)}}.call($this)
            ], 'k-wrapper', null, function() {try {return (dom => self.$slider = dom )} catch(e) {_e(e)}}.call($this)), 'k-bar-wrapper'),
            function() {try {return (isShowEnd && !marks )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, [
                    h('span', {
                        'ev-click': function() {try {return (self._setOneValue.bind(self, min) )} catch(e) {_e(e)}}.call($this)
                    }, function() {try {return (min + unit )} catch(e) {_e(e)}}.call($this)),
                    h('span', {
                        'ev-click': function() {try {return (self._setOneValue.bind(self, max) )} catch(e) {_e(e)}}.call($this)
                    }, function() {try {return (max + unit )} catch(e) {_e(e)}}.call($this))
                ], 'k-box') :
                undefined,
            function() {try {return (marks )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, function() {try {return (do {
            // const counts = step ? Math.floor((max - min) / step) : (max - min);
            const ret = [];
            for (let key in marks) {
                const mark = marks[key];
                const isActive = !isRange ? key == value : value.find(v => v == key) !== undefined;
                let text = mark;
                if (Array.isArray(mark)) {
                    text = isActive && mark[1] ? mark[1] : mark[0];
                }
                ret.push(
                    h('span', {
                    'style': function() {try {return ({
                            left: ((key - min) / (max - min) * 100) + '%'
                        } )} catch(e) {_e(e)}}.call($this),
                    'ev-click': function() {try {return (self._setOneValue.bind(self, key) )} catch(e) {_e(e)}}.call($this)
                }, function() {try {return (text )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({'k-active': isActive} )} catch(e) {_e(e)}}.call($this)))
                );
            }
            ret;
        } )} catch(e) {_e(e)}}.call($this), 'k-marks') :
                undefined
        ], 'k-slider-wrapper'),
        function() {try {return (isShowInput && !isRange )} catch(e) {_e(e)}}.call($this) ?
            h('div', null, h(Spinner, {
                'disabled': function() {try {return (disabled )} catch(e) {_e(e)}}.call($this),
                'max': function() {try {return (max )} catch(e) {_e(e)}}.call($this),
                'min': function() {try {return (min )} catch(e) {_e(e)}}.call($this),
                'step': function() {try {return (step || 0.01 )} catch(e) {_e(e)}}.call($this),
                'ref': function(i) {widgets['spinner'] = i},
                'vertical': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                'prefix': function() {try {return (spinnerPrefix )} catch(e) {_e(e)}}.call($this),
                'suffix': function() {try {return (spinnerSuffix )} catch(e) {_e(e)}}.call($this),
                '_context': $this,
                'value': _getModel(self, '_inputValue'),
                'ev-change': function() {try {return (self._onChange )} catch(e) {_e(e)}}.call($this),
                'ev-$change:value': function(__c, __n) { _setModel(self, '_inputValue', __n, $this) }
            }), 'k-spinner-wrapper') :
            undefined
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}